import React, { useEffect, useState } from "react";
import { Header } from "../header";
import { IMG_URl } from "../../common/img_url";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import OptionsProduct from "../OptionsProduct/OptionsProduct";
import {
  ProductCartElement,
  ProductDetails,
  ProductTags,
} from "./ProductElemnts";
import { Skeleton } from "../ui/skeleton";
import Iterator from "../utils/Iterator";
import ProductModel from "../../Models/PorductModel";
export default function NewProductScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { name, description, product, itemLoading } = indexStore();
  const params = useParams();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const height = Math.max(200, 300 - scrollY * 0.5); // Shrink down to 200px
  const [optionsSelected, setOptionsSelected] = useState([]);

  return (
    <>
      <Visibility visible={!itemLoading}>
        <div className="min-h-scree mb-24">
          <div
            className="w-full overflow-hidden transition-all duration-300"
            style={{ height: `${height}px` }}
          >
            <img
              src={`${IMG_URl}${product.image}`}
              alt={product.name_en}
              className="w-full h-full object-cover rounded-b-3xl shadow"
            />
          </div>

          <Header />
          <div className="p-5 space-y-3 ">
            <h1 className="text-2xl font-bold text-center">
              {product?.[name as keyof ProductModel]?.toString()}
            </h1>

            <ProductTags product={product} t={t} />
            <ProductDetails
              product={product}
              name={name}
              description={description}
            />

            <Visibility visible={product.option && product.option.length > 0}>
              <OptionsProduct
                options={product.option}
                name={name}
                price={product.price_offer || product.price}
                setOptionsSelected={setOptionsSelected}
                optionsSelected={optionsSelected}
              />
            </Visibility>
            <ProductCartElement
              productSheet={false}
              product={product}
              t={t}
              navigate={navigate}
              params={params}
              optionsSelected={optionsSelected}
              itemLoading={itemLoading}
            />
          </div>
        </div>
      </Visibility>
      <Visibility visible={itemLoading}>
        <div className="min-h-scree mb-24 ">
          <RenderProduct />
          <ProductCartElement
            productSheet={false}
            product={product}
            t={t}
            navigate={navigate}
            params={params}
            optionsSelected={optionsSelected}
            itemLoading={itemLoading}
          />
        </div>
      </Visibility>
    </>
  );
}
const RenderProduct = () => {
  return (
    <>
      <Skeleton className={"w-full h-80 rounded-b-3xl"} />
      <div className="flex p-4  items-center justify-center border-none shadow-none">
        <Skeleton className="w-1/3 h-8 " />
      </div>
      <div className="p-5 space-y-3">
        <div className="flex  items-center justify-center ">
          <Skeleton className="w-1/2 h-8 " />
        </div>

        <div className="flex gap-1 flex-wrap">
          <Skeleton className={"w-12 h-7"} />
          <Skeleton className={"w-12 h-7"} />
          <Skeleton className={"w-12 h-7"} />
        </div>
        <Skeleton className="w-48 h-5" />
        <div className="text-base font-semibold flex justify-end ">
          <Skeleton className={"w-12 h-7"} />
        </div>
        <div className="flex flex-col gap-3 ">
          <Skeleton className={"w-20 h-5"} />
          <div className="flex flex-col gap-2">
            <div className="px-1 flex flex-col gap-2">
              <Skeleton className={"w-16 h-5"} />
              <div className="px-2 flex flex-col gap-1 ">
                <Iterator
                  data={[1, 2, 3]}
                  render={() => (
                    <div className="flex items-center gap-3">
                      <Skeleton className={"w-4 h-4 rounded-full"} />
                      <Skeleton className={"w-40 h-5"} />
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="border-b-2 border-onBackground"></div>
          <div className="flex gap-1 justify-end">
            <Skeleton className={"w-40 h-6"} />
          </div>
        </div>
      </div>
    </>
  );
};
